import { Navigate, Outlet } from "react-router-dom"
import React, { useEffect, useState } from "react"
import { AuthData, useAuth } from "context/AuthProvider"
import { Puff } from "react-loader-spinner"
import { UserTypes } from "enum/UserTypes"
import { AuthService } from "services/AuthService"

/**
 * Home path for a signed-in role. Used when someone opens a route for a
 * different role (e.g. a Shopify merchant session on /super_admin/stores).
 */
const homeForRole = (role?: string): string => {
  switch (role) {
    case UserTypes.SUPER_ADMIN:
      return "/super_admin/place-orders"
    case UserTypes.DISPATCH:
      return "/dispatch/place-orders"
    case UserTypes.BUSINESS_CUSTOMER:
      return "/business_customer/place-orders"
    case UserTypes.PERSONAL_CUSTOMER:
      return "/persional_customer/place-orders"
    case UserTypes.DRIVER:
      return "/driver/available-orders"
    default:
      return "/signin"
  }
}

const isStaffRoute = (allowed: string): boolean =>
  allowed === UserTypes.SUPER_ADMIN || allowed === UserTypes.DISPATCH

const Authmiddleware = (props: any) => {
  const [user, , , authLoading, refreshUser] = useAuth() as AuthData
  const [restoringStaff, setRestoringStaff] = useState(false)
  const token = localStorage.getItem("token")
  const isValidToken =
    !!token &&
    !["null", "undefined", "", "[object Object]"].includes(token.trim()) &&
    token.trim().split(".").length === 3

  // Merchant onboard replaced the active JWT; put the stashed admin back.
  useEffect(() => {
    if (
      authLoading ||
      restoringStaff ||
      !isStaffRoute(props.allowed) ||
      user?.role === props.allowed ||
      !AuthService.hasStashedStaffSession()
    ) {
      return
    }
    let cancelled = false
    setRestoringStaff(true)
    if (AuthService.restoreStaffSession()) {
      refreshUser().finally(() => {
        if (!cancelled) {
          setRestoringStaff(false)
        }
      })
    } else {
      setRestoringStaff(false)
    }
    return () => {
      cancelled = true
    }
  }, [authLoading, props.allowed, refreshUser, restoringStaff, user?.role])

  if (!isValidToken && !AuthService.hasStashedStaffSession()) {
    localStorage.removeItem("token")
    return <Navigate to={{ pathname: "/signin" }} replace />
  }

  if (authLoading || restoringStaff) {
    return (
      <div
        className="d-flex justify-content-center align-items-center "
        style={{ height: "500px" }}
      >
        <Puff color="#FFD0B8" height={50} width={50} />
      </div>
    )
  }

  if (user?.role === props.allowed) {
    return <Outlet />
  }

  if (!user?.role) {
    localStorage.removeItem("token")
    return <Navigate to={{ pathname: "/signin" }} replace />
  }

  return <Navigate to={{ pathname: homeForRole(user.role) }} replace />
}

export default Authmiddleware
